import '../styles/page.scss'

export const Page = (props) =>
{
    return <div className="page">
        {props.children}
    </div>
}